import React from 'react';
import classNames from 'classnames';
import "./UISwitch.css";
import { jsx as _jsx } from "react/jsx-runtime";
function UISwitch(_ref) {
  var on = _ref.on,
    id = _ref.id,
    className = _ref.className,
    isInvalid = _ref.isInvalid,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onClick = _ref.onClick,
    dataTestId = _ref['data-testid'];
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    _jsx("button", {
      type: "button",
      className: classNames('btn', 'btn-switch', className, {
        active: on
      }, {
        'is-invalid': isInvalid
      }),
      id: id,
      onClick: onClick,
      disabled: disabled,
      "data-testid": dataTestId,
      children: /*#__PURE__*/_jsx("div", {
        className: "handle"
      })
    })
  );
}
export default UISwitch;
//# sourceMappingURL=UISwitch.js.map